import { HttpInterceptorFn } from '@angular/common/http';

const AUTH_URLS = ['auth'];
const REFRESH_URLS = ['/user/logout', '/user/refresh'];
const JWT_KEY = 'jwt';
const REFRESH_KEY = 'refresh';

export const mainInterceptor: HttpInterceptorFn = (req, next) => {
  const url = req.url.toLowerCase();

  if (AUTH_URLS.some(path => url.includes(path))) {
    return next(req);
  }

  const headers: Record<string, string> = {};

  if (REFRESH_URLS.some(path => url.includes(path))) {
    const refreshToken = localStorage.getItem(REFRESH_KEY);
    if (refreshToken) headers['X-Refresh-Token'] = refreshToken;
  } else {
    const jwt = localStorage.getItem(JWT_KEY);
    if (jwt) headers['Authorization'] = jwt;
  }
  return headers
    ? next(req.clone({ setHeaders: headers }))
    : next(req);
};
